// apps/web/src/pages/Announcements/components/AnnouncementSummary.tsx
//
// Render do resumo de um comunicado (`announcements.summary`). O campo é
// rich-text inline: o admin o edita num editor WYSIWYG, então o valor chega
// sempre como HTML (`<p>…</p>` mesmo num parágrafo único sem formatação).
// Interpolar essa string em JSX mostra a marcação como texto na tela — todo
// consumidor do resumo passa por este componente.
//
// Sanitiza no profile 'inline' (espelho da allowlist do backend, sem blocos e
// sem style) antes de injetar. `clamp` corta em 2 linhas para teaser de card /
// banner e torna o <p> inline para o corte medir o texto, não o parágrafo.
//
// Com o <p> inline a fronteira entre parágrafos vizinhos some e as palavras se
// emendam ("…sua gestão.Impulsione…"). O `::before` com um espaço nos <p> que
// não são o primeiro repõe essa fronteira — mesmo resultado que o backend
// produz ao trocar `</p>` por espaço em announcement-html.sanitizer.ts.

import { cn } from '@alamo/ui';

import { SanitizedHtml } from './SanitizedHtml';

export interface AnnouncementSummaryProps {
  html: string;
  /** Teaser: corta em 2 linhas com reticências (card do feed, banner do painel). */
  clamp?: boolean;
  className?: string;
}

export function AnnouncementSummary({ html, clamp = false, className }: AnnouncementSummaryProps) {
  return (
    <SanitizedHtml
      html={html}
      profile="inline"
      className={cn(
        '[&_p]:m-0',
        clamp && "line-clamp-2 [&_p]:inline [&_p:not(:first-child)]:before:content-['_']",
        className,
      )}
    />
  );
}
